/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SysqueCheckBoxVM } from '../../models/sysque-check-box-vm';

@Component({
  selector: 'sysque-check-box-options-line',
  templateUrl: './sysque-check-box-options-line.component.html',
  styleUrls: ['./sysque-check-box-options-line.component.scss'],
  standalone: false
})
export class SysqueCheckboxOptionsLineComponent implements OnInit{
  @Input() label: string;
  @Input() checkboxItems: SysqueCheckBoxVM[];
  @Output() valueChanged: EventEmitter<SysqueCheckBoxVM> = new EventEmitter<SysqueCheckBoxVM>();
  items: SysqueCheckBoxVM[] = [];

  ngOnInit(): void {
      for(let value of this.checkboxItems){
        this.items.push({label: value.label, isChecked: value.isChecked});
      }
  }

  onValueChanged(value: boolean, label: string) {
    this.valueChanged.emit({isChecked: value, label: label});
  }
}
